const paths = {
  telemetryTemperature: '/telemetry/temperature',
  telemetryFuelMonitor: '/telemetry/fuel/monitor',
  telemetryFuelReport: '/telemetry/fuel/report',
  telemetryFuelLoadsReport: '/telemetry/fuel/loads/report',
  telemetryFuelReportByVehicles: '/telemetry/fuel/vehicles/report',
  telemetryFuelReportByVehiclesWeekly: '/telemetry/fuel/vehicles/weekly',
  telemetryUnits: '/telemetry/units',
  telemetryOBD2: '/telemetry/obd2'
};

export default paths;
